import React from 'react';

export const StateContext = React.createContext(null);
const DispatchContext = React.createContext(null);
